import React from 'react';
import { Box } from '@mui/material';
import TemporalGraph from '../components/forecast_metrics-components/graph_temporal.js';
import ForecastButtonsContainer from '../components/forecast_metrics-components/ForecastButtonsContainer.js';

const ForecastTemporalView = ({
  cqlFecha,
  cqlFechaMax,
  cqlFechaMin,
  issueTime,
  cqlSevere,
  weekNumber,
  metricsName,
  issueTimeOptions,
  selectedTime,
  handleRiskClick,
  mapLeftLayer,
  handleDateChange,
  handleModelClick,
  selectedModel
}) => {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          cursor: 'crosshair',
          height: '100%',
          minHeight: 0,
          overflow: 'hidden',
        }}
      >
        <Box sx={{ 
          height: '100%', 
          minHeight: 0,
          backgroundColor: 'rgba(35, 155, 105, 0.25)', 
          backdropFilter: 'blur(20px)',
          WebkitBackdropFilter: 'blur(20px)',
          border: '1px solid rgba(255, 255, 255, 0.05)', 
          borderRadius: 2, 
          p: { xs: 0.1, sm: 0.15 },
          overflow: 'auto',
          boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
        }}>
          <TemporalGraph
            cqlFecha={cqlFecha}
            cqlFechaMax={cqlFechaMax}
            cqlFechaMin={cqlFechaMin}
            issueTime={issueTime}
            cqlSevere={cqlSevere}
            weekNumber={weekNumber}
            metricsNames={metricsName}
            issueTimeOptions={issueTimeOptions}
            selectedTime={selectedTime}
            handleRiskClick={handleRiskClick}
            mapLeftLayer={mapLeftLayer}
          />
        </Box>
      </Box>
    </>
  );
};

export default ForecastTemporalView;
